module.exports = __webpack_public_path__ + "img/dining-art.fea71e78.webp";